import publicAPI from '../../api/public';

export default {
  namespaced: true,

  state: {
    pagesTree: [],
    currentPage: null,
    loading: false,
    error: null,
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },

    SET_ERROR(state, error) {
      state.error = error;
    },

    SET_PAGES_TREE(state, tree) {
      state.pagesTree = tree;
    },

    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },

    CLEAR_CURRENT_PAGE(state) {
      state.currentPage = null;
    },
  },

  actions: {
    async fetchTree({ commit, rootGetters }, pageType) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const locale = rootGetters['locale/current'];
        const tree = await publicAPI.fetchPagesTree(locale, pageType);
        commit('SET_PAGES_TREE', tree);
      } catch (error) {
        commit('SET_ERROR', error.message);
        console.error('Failed to fetch pages tree:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchPage({ commit, rootGetters }, { slug, pageType }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const locale = rootGetters['locale/current'];
        const page = await publicAPI.fetchPage(locale, pageType, slug);
        commit('SET_CURRENT_PAGE', page);
      } catch (error) {
        commit('SET_ERROR', error.message);
        console.error('Failed to fetch page:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },

  getters: {
    pagesTree: state => state.pagesTree,
    currentPage: state => state.currentPage,
    loading: state => state.loading,
    error: state => state.error,
  },
};
